<template>
  <div v-if="loading" class="cfs-loading position-fixed">
    <div class="cfs-loading__container">
      <div class="d-flex justify-center align-center mt-3">
        <div class="primary rounded py-2 px-5 d-flex">
          <CfsIcon class="cfs-loading__icon" :icon-name="RefreshIcon" :max-width="17" />
          <span class="text-s white--text ml-2">{{ title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import RefreshIcon from '@/assets/img/icons/reload/refresh.svg';

export default defineComponent({
  name: 'CfsLoading',
  props: {
    loading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { RefreshIcon };
  },
});
</script>

<style lang="scss" scoped>
.cfs-loading {
  width: 100vw;
  height: 100vh;

  top: 0;
  left: 0;
  z-index: 10;

  background-color: rgba(240, 240, 240, 0.6);

  &__icon {
    animation: spinner 1s infinite;

    @keyframes spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
